import { supportCenterData } from "./supportData";

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const supportService = {
  getCategories: async () => {
    await delay(300);
    return { data: supportCenterData.categories, status: 200 };
  },

  getTutorials: async () => {
    await delay(500);
    return { data: supportCenterData.tutorials, status: 200 };
  },

  getFaqs: async () => {
    await delay(400);
    return { data: supportCenterData.faqs, status: 200 };
  },

  getSupportTickets: async (userId, status = "all") => {
    await delay(600);
    let tickets = supportCenterData.supportTickets;

    if (status !== "all") {
      tickets = tickets.filter(ticket => ticket.status.toLowerCase() === status.toLowerCase());
    }

    return {
      data: {
        tickets,
        counts: supportCenterData.ticketCounts,
      },
      status: 200,
    };
  },

  getQuickResources: async () => {
    await delay(300);
    return { data: supportCenterData.quickResources, status: 200 };
  },

  submitSupportTicket: async (userId, ticketData) => {
    await delay(800);
    const newTicket = {
      id: Date.now(),
      title: ticketData.subject,
      status: "Open",
      tags: [ticketData.topic],
      date: "Today",
      time: new Date().toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }),
    };

    return {
      data: {
        ticket: newTicket,
        message: "Support ticket submitted successfully",
      },
      status: 201,
    };
  },

  updateTicketStatus: async (userId, ticketId, status) => {
    await delay(500);
    return {
      data: {
        ticketId,
        status,
        updatedAt: new Date().toISOString(),
        updatedBy: userId,
      },
      status: 200,
    };
  },

  addTicketComment: async (userId, ticketId, comment) => {
    await delay(400);
    return {
      data: {
        commentId: Date.now(),
        ticketId,
        comment,
        createdAt: new Date().toISOString(),
        createdBy: userId,
      },
      status: 201,
    };
  },

  searchKnowledgeBase: async query => {
    await delay(600);
    return {
      data: {
        query,
        results: supportCenterData.faqs.filter(
          faq =>
            faq.question.toLowerCase().includes(query.toLowerCase()) ||
            faq.answer.toLowerCase().includes(query.toLowerCase())
        ),
        totalResults: 3,
      },
      status: 200,
    };
  },
};
